import React, { useMemo, useState } from 'react';
import koreaCampaignData from '../assets/avocadogiant_korea_campaign_grid_items.json';
import globalCampaignData from '../assets/avocadogiant_global_campaign_grid_items.json';
import CampaignGridCard from '../components/section/CampaignGridCard';
import {
  PageGrid,
  PageHeader,
  PageHeaderText,
  PageLabel,
  PageTitle,
  PageWrapper,
  Tab,
  TabGroup,
} from '../components/section/pageLayout';
import { SectionInner } from '../components/section/common';
import PageContainer from '../view/page-container';
import { dedupeCampaignItems, type CampaignItem } from '../utils/listingData';

const globalItems = (globalCampaignData as { items: CampaignItem[] }).items;

const CampaignPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'korea' | 'global'>('korea');
  const koreaItems = koreaCampaignData as CampaignItem[];

  const visibleItems = useMemo(() => {
    const source = activeTab === 'korea' ? koreaItems : globalItems;
    return dedupeCampaignItems(source);
  }, [activeTab, koreaItems]);

  return (
    <PageContainer>
      <PageWrapper>
        <SectionInner>
          <PageHeader>
            <PageHeaderText>
              <PageLabel>CAMPAIGNS</PageLabel>
              <PageTitle>캠페인</PageTitle>
            </PageHeaderText>
            <TabGroup>
              <Tab
                style={{ color: activeTab === 'korea' ? '#CEDA87' : '#555555' }}
                $active={activeTab === 'korea'}
                type="button"
                onClick={() => setActiveTab('korea')}
              >
                Korea
              </Tab>
              <Tab
                style={{
                  color: activeTab === 'global' ? '#CEDA87' : '#555555',
                }}
                $active={activeTab === 'global'}
                type="button"
                onClick={() => setActiveTab('global')}
              >
                Global
              </Tab>
            </TabGroup>
          </PageHeader>

          <PageGrid>
            {visibleItems.map((item) => (
              <CampaignGridCard key={item.sourceItemId} item={item} />
            ))}
          </PageGrid>
        </SectionInner>
      </PageWrapper>
    </PageContainer>
  );
};

export default CampaignPage;
